export default __webpack_public_path__ + "static/media/Image-Success.d81840ee.png";